/* eslint-disable import/no-extraneous-dependencies */
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { History } from "history";

let appInsights: ApplicationInsights = null;

/**
 * - Initializes Microsoft's App Insight with react plugin.
 * - NOTE: Only one reference is created
 * @param {ReactPlugin} plugin
 */
const initAppInsights = (plugin: ReactPlugin) => (
  instrumentationKey: string,
  browserHistory: History,
) => {
  if (!browserHistory) {
    throw new Error("Could not initialize Telemetry Service");
  }
  if (!instrumentationKey) {
    throw new Error("Instrumentation key not provided");
  }

  if (!appInsights) {
    appInsights = new ApplicationInsights({
      config: {
        instrumentationKey,
        extensions: [plugin],
        extensionConfig: {
          [plugin.identifier]: {
            history: browserHistory,
          },
        },
      },
    });

    appInsights.loadAppInsights();
  }

  return appInsights;
};

/**
 * Get reference to appInsight object
 */
const getAppInsights = () => appInsights;

export { initAppInsights, getAppInsights };



// WEBPACK FOOTER //
// ./src/appInsights/utils/initAppInsights.ts